$(function() {

	// alert('footer script');

})